// ─── Screens that are switched off, and why ──────────────────────────────────
//
// The Academy is back (sprint 12, stage 3 · 28/09/2026), rewritten as
// factual content with a source for every figure. The content lives in
// academy/*.md and reaches the app through `npm run academy`
// (scripts/build-academy.js → src/data/academyContent.json). This flag still
// controls the menu, the sidebar, the in-app links, the Q&A category, the
// "מושג השבוע" card and the /academy path (App.js, index.js, netlify.toml).
export const ACADEMY_ENABLED = true;

// Lesson 6.2 ("מידע, שיווק וייעוץ: מה החוק בישראל אומר") and its quiz
// question are hidden until counsel approves them (DECISIONS.md, plan.md).
export const LESSON_6_2_ENABLED = false;

// The investor profile is hidden (David, 27/09/2026 · DECISIONS.md). The
// questionnaire asks about goals, horizon and the share of savings invested,
// and "הפרופיל שלי" answers with a label (שמרן / מאוזן / אגרסיבי) and habits
// written for that label. Section 12 of the Investment Advice Law describes
// exactly that sequence · find out about the client, then fit the content to
// them · and that is licensed work. This flag takes out the "הפרופיל שלי"
// screen (menu, sidebar, overlay, /profile), the questionnaire for new users,
// the settings card that restarts it (restarting DELETES the stored row, and
// existing answers stay in investor_profiles), the Q&A entry about it, and the
// home-screen spacing it chose. Code and stored answers are untouched. A new
// user still gets the optional name screen on its own (NameOnlyFlow).
export const INVESTOR_PROFILE_ENABLED = false;

// The calculators screen is hidden (David, 27/09/2026 · DECISIONS.md). It
// projects a return (20 years at 8% a year) and applies a 15% "foreign" tax
// rate, neither with a source. Menu, sidebar, overlay and /calculators (302 to
// the home screen, netlify.toml) all follow this flag. "מה אם" is a different
// screen (ScenarioTab, sprint 13) and is not covered by it.
export const CALCULATORS_ENABLED = false;

// Finnhub figures beyond the price are hidden everywhere, the same way
// (David, 27/09/2026): whether the Finnhub licence lets the app show them is
// an open question for counsel (ROADMAP, "לעו״ד"). Covered: P/E, EPS, Beta,
// market cap and dividend yield in the holding panel; analyst estimates in the
// holding panel, the calendar and "דוחות השבוע"; weighted P/E and estimated
// dividend in "מה אם" (a reserved, empty place in ScenarioTab); P/E and Yield% in the CSV export. Report DATES stay.
// Prices, ranges and SEC-reported figures stay.
export const FINNHUB_VALUATION_ENABLED = false;

// Price alerts (sprint 14, 4.4). Checked end to end in code and in tests
// (src/utils/checkPriceAlerts.test.js): save under RLS, the 15-minute check,
// the push, one-shot deactivation. Not yet seen on a real device in
// production. Off hides the "הגדר התראת מחיר" button, the drawer and the
// header mark; the alerts already saved stay in price_alerts.
export const PRICE_ALERTS_ENABLED = true;
